import Icon from '../components/Icon.vue'

Icon.register({
  'cart-arrow-down': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M504.7 320h-293.1l6.5 32h268.4c15.4 0 26.8 14.3 23.4 29.3l-5.5 24.3c18.7 9.1 31.6 28.2 31.6 50.4 0 31.2-25.5 56.4-56.8 56-29.8-0.4-54.3-24.6-55.2-54.4-0.4-16.3 6.1-31 16.8-41.5h-209.6c10.4 10.2 16.8 24.3 16.8 40 0 31.8-26.5 57.4-58.7 55.9-28.5-1.3-51.8-24.4-53.3-52.9-1.2-22 10.4-41.5 28.1-51.6l-70.2-343.4h-69.9c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h102.5c11.4 0 21.2 8 23.5 19.2l9.2 44.8h392.8c15.4 0 26.8 14.3 23.4 29.3l-47.3 208c-2.5 10.9-12.2 18.7-23.4 18.7zM403 192h-43v-60c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v60h-43c-10.7 0-16 12.9-8.5 20.5l67 67c4.7 4.7 12.3 4.7 17 0l67-67c7.6-7.6 2.2-20.5-8.5-20.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cart-arrow-down.js
// module id = 1162
// module chunks = 0